const validate = (values) => {
  const errors = {};

  if (!values.roleName || values.roleName.trim() === '') {
    errors.roleName = 'Please enter role';
  }
  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/userRoles/validate.js